import React, {
  Component,
  Fragment,
  useState,
  useLayoutEffect,
  useEffect,
} from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  getCardSkills,
  excecuteCardSkill,
  updateCardSkills,
  deleteCardSkill,
} from '../skill_builder/steps/CardActions';
import SelectCard from '../skill_builder/steps/cardInvocationDetails/SelectCard';
import { getCardTemplates } from '../skill_builder/steps/CardActions';
import EditSkill from '../EditSkill';
import { addActivityLog } from '../../common/activityLog';
import SkillConnectModal from '../cardSkill/connectionModal';
import queryString from 'query-string';
import axios from 'axios';
import CreationPage from '../cardSkill/reportCreationPage';
// import jwt from 'jsonwebtoken';
//  let  res=await this.props.getCurrentSkill(this.props.match.params.wId,query)
import {
  getChannelList,
  getCurrentSkill,
  getSkillUser,
  checkConfigLimit,
} from '../../skills/skills_action';

import {
  handleSelectedProject,
  setTemplate,
  handleEditMode,
  handleTemplateFormat,
  card_template_id,
} from '../cardSkill/report_actions';
import {
  CloseOutlined,
  GithubOutlined,
  SearchOutlined,
  DownOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import '../cardSkill/cardSkill.css';
import Highlighter from 'react-highlight-words';
import {
  Button,
  Table,
  Divider,
  Card,
  Menu,
  Dropdown,
  Row,
  Col,
  message,
  notification,
  Tag,
  Avatar,
  Layout,
  Radio,
  Icon,
  Input,
  PageHeader,
  Tooltip,
  Tabs,
  Typography,
} from 'antd';

import { cardInfo } from '../cardSkill/report_actions';
import { templateData } from '../cardSkill/templateData';
import { isValidUser } from '../../../utils/utils';
import ReportLandingPage from '../cardSkill/report_landing_page';
const { Meta } = Card;
const { Text } = Typography;
const { CheckableTag } = Tag;
const { Content } = Layout;
const { TabPane } = Tabs;
const tagsFromServer = ['Jira', 'GitHub'];

function onradioselect(event) { }

const CardSkillList = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [channelsLoading, setChannelsLoading] = useState(false);
  const [isReportLandingPage, setIsReportLandingPage] = useState(false);
  const [cardSkillWithuser, setCardSkillWithuser] = useState();
  const [warning, setWarning] = useState({});
  const [reportScope, setReportScope] = useState('');

  const [isCreate, setIsCreate] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedCardSkill, setSelectedCardSkill] = useState(null);

  const [showListReportPage, setShowListReportPage] = useState(false);
  const [showChartReportPage, setShowChartReportPage] = useState(false);
  const [ShowCreationPage, setShowCreationPage] = useState(false);
  const [chartType, setChartType] = useState('');
  const [currentTab, setCurrentTab] = useState('my_reports');

  const [isEditMode, setIsEditMode] = useState(false);
  const newTemplateData = useSelector((state) => state.cards.templateCards);

  useEffect(() => {
    dispatch(getCardTemplates(props.match.params.wId, 'app_home=true'));
  }, []);
  let skill = {};
  useEffect(() => {
    setLoading(true);
    // const parsedQueryString = queryString.parse(props.location.search);
    // if (
    //   (props.channels && props.channels.length === 0) ||
    //   (parsedQueryString.from &&
    //     parsedQueryString.from === 'jira_conection_onboarding')
    // ) {
    //   // this.setState({ channelsLoading: true });
    //   setChannelsLoading(true);
    //   props
    //     .getChannelList(props.match.params.wId)
    //     .then((res) => setChannelsLoading(false));
    // }
    // let query = '';

    if (props.skill) {
      let query = 'app_home=' + true;

      props.getCardTemplates(props.match.params.wId, query);

      skill = props
        .getCardSkills(props.match.params.wId, 'app_home')
        .then((res) => {
          if (res.data.success) {
            setUserNameInCardSkills(res.data.CardSkills);
            setLoading(false);
          }
        });
    } else {
      skill = props.getCardSkills(props.match.params.wId, 'app_home');
    }
    // })

    if (props.skillView && props.skillView.report_id) {
      setIsReportLandingPage(true);
      setReportScope(true);
    }

    let isCreate_ = props.location.search.split('=')[2] === 'true';
    if (isCreate_) {
      // this.setState({ isCreate: true });
      setIsCreate(true);
    }
  }, []);

  useEffect(() => {
    if (props && props.cardSkills) setUserNameInCardSkills(props.cardSkills);
    setLoading(false);
  }, [props.cardSkills]);

  const setUserNameInCardSkills = (CardSkills) => {
    let cardSkillWithuser = [];
    CardSkills.forEach((report) => {
      // console.log(this.props.allUsers);
      const userFound = report.user_id;

      if (userFound.email) {
        // report.user_id = userFound
        report.creator_name =
          userFound.displayName ||
          userFound.name ||
          userFound.user_name ||
          userFound.email;
      } else {
        report.creator_name = 'Not a member';
      }

      //for channel search
      // let channelPresent = report.slackData && this.props.channels.find(c => c.id ===  report.slackData.slackChannel);
      let channelPresent = [];
      let isChannelPresent =
        report.slackData &&
        report.slackData.slackChannel &&
        report.slackData.slackChannel;
      if (Array.isArray(isChannelPresent)) {
        let channelDetails;
        isChannelPresent.forEach((channel) => {
          channelDetails = false;
          channelDetails = props.channels.find((c) => c.id === channel);
          if (channelDetails) {
            channelPresent.push(channelDetails);
          }
        });
      } else {
        channelPresent = props.channels.find((c) => c.id === isChannelPresent);
      }

      if (channelPresent) {
        report.channel_name = channelPresent;
      } else {
        report.channel_name = '';
      }
      cardSkillWithuser.push(report);
    });

    // this.setState({ cardSkillWithuser });
    setCardSkillWithuser(cardSkillWithuser);
  };

  const closeWarningModal = () => {
    // this.setState({ warning: { status: false } });
  };
  const goToConnection = () => {
    const { currentSkillUser } = props;

    closeWarningModal();
    let url =
      '/' +
      props.match.params.wId +
      '/skills/' +
      warning.skill._id +
      '/' +
      props.match.params.sub_skill;

    if (
      !(currentSkillUser.token_obj && currentSkillUser.token_obj.access_token)
    ) {
      url += '?view=personal_preferences';
    }

    props.history.push(url);
  };

  const getReleventReports = (reports) => {
    const { user_now } = props;
    if (currentTab === 'all_reports') return reports;
    else {
      return (
        reports &&
        reports.filter((report) => report.user_id.user_id === user_now._id)
      );
    }
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type='primary'
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size='small'
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size='small'
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => <SearchOutlined />,
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          textToHighlight={text.toString()}
          autoEscape
        />
      ) : (
        text
      ),
  });

  const gotoReportLandingPage = (id) => {
    props.history.push(
      `/${props.match.params.wId}/skills/${props.match.params.skill_id}/${props.match.params.sub_skill}?view=appHome&report_id=${id}`
    );
    // this.setState({ isReportLandingPage: true });
    setIsReportLandingPage(true);
  };

  const validateChannels = (channels, selectedChannels) => {
    let notExistChannels = [];
    if (selectedChannels) {
      if (Array.isArray(selectedChannels)) {
        selectedChannels.map((schannel) => {
          if (channels.some((channel) => channel.id === schannel)) {
          } else {
            notExistChannels.push(schannel);
          }
        });
      } else {
        if (channels.find((c) => c.id === selectedChannels)) {
        } else {
          notExistChannels = selectedChannels;
        }
      }
    }
    return notExistChannels;
  };

  const skillTokenValidation = async (template) => {
    // return new Promise(async(resolve,rej)=>{
    if (template.app === 'Jira' || template.app === 'GitHub') {
      let skill = {};
      let currentSkillUser = {};

      if (props.skill) {
        skill = props.skill;
        // this.props.currentSkill.skill_metadata
      } else {
        let query = 'name=' + template.app;
        let res = await props.getCurrentSkill(props.match.params.wId, query);
        skill = res.data.skill;
      }

      if (
        props.currentSkillUser &&
        Object.keys(props.currentSkillUser).length == 0
      ) {
        currentSkillUser = await props.getSkillUser(
          props.match.params.wId,
          props.match.params.skill_id
        );
      } else {
        currentSkillUser = props.currentSkillUser;
      }
      if (
        skill &&
        ((skill.skill_metadata && skill.skill_metadata.linked) || skill.linked)
      ) {
        if (template.app === 'Jira') {
          if (template.meta && template.meta.isToken) {
            if (
              (skill.userName && skill.userToken) ||
              (skill &&
                skill.metadata &&
                (skill.metadata.server_type === 'jira_server' ||
                  skill.metadata.server_type == 'jira_server_oauth' ||
                  skill.metadata.server_type == 'jira_cloud_oauth'))
            ) {
              if (
                !(
                  currentSkillUser.token_obj &&
                  currentSkillUser.token_obj.access_token
                )
              ) {
                setWarning({
                  status: true,
                  skill: skill,
                  type: 'user_not_verified',
                });
                message.info('USER NOT VERIFIED #1');
              } else {
                return 'create_modal';
              }
            } else {
              setWarning({
                status: true,
                skill: skill,
                type: 'jira_basic_token',
              });
              message.info('JIRA BASIC TOKEN #2');
            }
          } else if (
            !(
              currentSkillUser.token_obj &&
              currentSkillUser.token_obj.access_token
            )
          ) {
            setWarning({
              status: true,
              skill: skill,
              type: 'user_not_verified',
            });
            message.info('USER NOT VERIFIED #3');
          } else {
            return 'create_modal';
          }
        }
      } else {
        setWarning({ status: true, skill: skill, type: 'skill_not_connected' });
        message.info('Skill Not Connected');
      }
    } else {
      return 'create_modal';
    }

    // })
  };

  const showErrorMessage = (err) => {
    message.error(
      err || `You don't have permission to modify this skill. Only Creator or admin can modify it`
    );
  };

  const onSkillEdit = (skill) => {
    let isCreator = isValidUser(skill);
    if (isCreator || props.isAdmin) {
      // this.setState({ showEditModal: true, selectedTemplate: skill });
      setSelectedCardSkill(skill);

      setShowEditModal(true);
    } else {
      showErrorMessage();
    }
  };

  const execRunNow = async (skill) => {
    let isCreator = isValidUser(skill);
    //id=Zynga
    if (isCreator || props.isAdmin) {
      let modal = await skillTokenValidation(
        skill.cardInformation.card_template_id
      );
      if (modal === 'create_modal') {
        notification.success({
          key: 'runNowStatus',
          message: 'Request submitted',
          description:
            'If there is data to be sent, it will reach the configured Slack channel',
          placement: 'bottomLeft',
          duration: 3,
        });

        props.excecuteCardSkill(props.match.params.wId, skill._id);
      }
    } else {
      showErrorMessage();
    }
  };

  const toggleSkill = async (record) => {
    let isCreator = isValidUser(record);
    if (isCreator || props.isAdmin) {
      try {
        const res = await props.updateCardSkills(props.match.params.wId, {
          _id: record._id,
          is_enabled: !record.is_enabled,
          EditOnly: true,
        })
        if (res?.data?.success) {
          message.success('Report updated');
        } else {
          showErrorMessage(res?.data?.message || "Error updating report");
        }
      } catch (e) {
        console.error(e);
        showErrorMessage(e.message || "Error updating report");
      }
    } else {
      showErrorMessage();
    };
  }

  const showConfigModal = async (skill, e) => {
    e.preventDefault();
    // eslint-disable-next-line no-console
    let isCreator = isValidUser(skill);
    let skills = {};
    let query = '';

    if (isCreator || props.isAdmin) {
      let modal = await skillTokenValidation(
        skill.cardInformation.card_template_id
      );
      if (modal === 'create_modal') {
        if (props.skill) {
          query = 'app=' + props.skill.name;
          skills = props.getCardSkills(
            props.match.params.wId,
            'app_home',
            props.skill.name
          );
        } else {
          skills = props.getCardSkills(props.match.params.wId, 'app_home');
        }
        /* getChannels only called once in sidenavbar_new */
        // let channels = this.props.getChannelList(this.props.match.params.wId)
        Promise.all([skills /* , channels */]);

        // props.getCardTemplates(props.match.params.wId, query);
        // props.getAllUsers(props.match.params.wId);
        //>>>>>>>>>>>>>>>>>>>>>>>
        let isCreator = isValidUser(skill);
        if (
          isCreator ||
          props.match.params.wId == '5f84c0d0b038174751d7b805' ||
          props.isAdmin
        ) {
          let modal = await skillTokenValidation(
            skill.cardInformation.card_template_id
          );
          if (modal === 'create_modal') {
            dispatch(setTemplate(skill));
            dispatch(handleEditMode(true));
            let templateUsed = newTemplateData.find(
              (ct) => ct.key === skill.cardInformation.key
            );
            setSelectedTemplate(templateUsed);
            setSelectedCardSkill(skill);
            // setShowEditModal(true);
            dispatch(card_template_id(templateUsed));
            dispatch(cardInfo(skill.cardInformation.cardInformation));
            setIsEditMode(true);
            props.history.push(
              `/${props.match.params.wId}/skills/${props.match.params.skill_id}/${props.match.params.sub_skill}?view=appHome&report_id=${skill._id}`
            );
            setShowCreationPage(true);
          }
        } else {
          showErrorMessage();
        }
      }
    } else {
      showErrorMessage();
    }
  };

  const goToReports = () => {
    props.history.push(
      `/${props.match.params.wId}/skills/${props.match.params.skill_id}/${props.match.params.sub_skill}?view=appHome`
    );
    setIsReportLandingPage(false);
  };

  const onReportDelete = (report) => {
    // console.log("comming");
    let isCreator = isValidUser(report);
    if (isCreator || props.isAdmin) {
      props
        .deleteCardSkill(props.match.params.wId, report._id)
        .then((res) => {
          message.success('Report deleted');
          props.history.push(
            `/${props.match.params.wId}/skills/${props.match.params.skill_id}/${props.match.params.sub_skill}?view=reports`
          );
          setIsReportLandingPage(false);
        })
        .catch((e) => {
          // console.log(e);
          // console.error(e);
        });
    } else {
      showErrorMessage();
    }
  };

  const handleReportScopeChange = (val) => {
    setReportScope(val);
  };
  const table_columns = [
    {
      className: 'response_column_without_table_top',
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      width: '200',

      render: (text, data) => {
        return (
          <Tooltip placement='topLeft' title={text} trigger='hover'>
            <Button type='link' onClick={() => gotoReportLandingPage(data._id)}>
              <span
                style={{
                  maxWidth: 200,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {text}
              </span>
            </Button>
          </Tooltip>
        );
      },
    },
    {
      className: 'response_column_without_table_top',
      title: 'Creator',
      dataIndex: 'creator_name',
      // key: "user_id",
      align: 'center',
      render: (text, record) => {
        // return <span>
        //   {this.props.allUsers && this.props.allUsers.map(user => {
        //     if (text === user.user_id) {
        //       return user.name
        //     } else {
        //       return false
        //     }
        //   })}
        // </span>
        // const userFound = this.props.allUsers.find(user => user.user_id === text)
        // if(userFound) return userFound.name
        // else return 'Not a member'
        // render: (text, data) => "heeloworld",
        return <span>{text}</span>;
      },
      // ...this.getColumnSearchProps('creator_name'),
    },
    {
      title: 'Status',
      key: 'is_enabled',
      align: 'center',
      dataIndex: 'is_enabled',
      maxWidth: 100,
      width: 100,
      sorter: (a, b) =>
        (a.is_enabled ? 'Enabled' : 'Not Enabled').length -
        (b.is_enabled ? 'Enabled' : 'Not Enabled').length,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => {
        if (record.is_enabled) {
          return <Tag color='green'>Enabled</Tag>;
        } else {
          return <Tag color='orange'>Not Enabled</Tag>;
        }
      },
    },

    {
      title: 'Actions',
      key: 'actions',
      align: 'center',
      width: 150,
      render: (text, record) => {
        let menu = (
          <Menu>
            <Menu.Item key='1'>
              <div
                onClick={() => onSkillEdit(record)}
                style={{ width: '100%' }}
              >
                Edit
              </div>
            </Menu.Item>
            <Menu.Item key='2' disabled={!record.is_enabled}>
              <div style={{ width: '100%' }} onClick={() => execRunNow(record)}>
                Run Now
              </div>
            </Menu.Item>
            <Menu.Item key='3' onClick={() => toggleSkill(record)}>
              <div style={{ width: '100%' }}>
                {record.is_enabled ? 'Disable' : 'Enable'}
              </div>
            </Menu.Item>
          </Menu>
        );
        return (
          <span>
            <a onClick={(e) => showConfigModal(record, e)}>Configure</a>
            <Divider type='vertical' />
            <Dropdown overlay={menu}>
              <a>More</a>
            </Dropdown>
          </span>
        );
      },
    },
  ];

  const showTemplates = () => {
    setIsCreate(true);
  };

  const hideTemplates = () => {
    setIsCreate(false);
  };


  const handleTabChange = (val) => {
    setCurrentTab(val);
  };
  const checkLimitAndProceed = async (callback) => {
    try {
      const res = await checkConfigLimit(props.match.params.wId, 'config');
      if (!res.success) {
        message.error(res.message || 'Failed to check configuration limit.');
        return;
      }
      callback();
    } catch (err) {
      console.error('checkLimitAndProceed error', err);
      message.error('Failed to check configuration limit. Please try again.');
    }
  };

  const menu = (
    <Menu>
      <Menu.Item
        key='1'
        onClick={() => checkLimitAndProceed(() => {
          setShowChartReportPage(true);
          setShowCreationPage(true);
          setChartType('chart');
          // if (!props.isEditMode) {
          let res = newTemplateData.find((t) => t.key === 'custom_report_2');
          dispatch(handleTemplateFormat(res));
          setSelectedTemplate(res);
          dispatch(cardInfo(res.defaultValues));

          // }
        })}
      >
        + Chart Report
      </Menu.Item>
      <Menu.Item
        key='2'
        onClick={() => checkLimitAndProceed(() => {
          let template = newTemplateData.find(
            (t) => t.name == 'Issues by Custom JQL'
          );
          setShowListReportPage(true);
          setShowCreationPage(true);
          setChartType('list');
          setSelectedTemplate(template);
          dispatch(handleTemplateFormat(template));
          dispatch(cardInfo(template.defaultValues));
        })}
      >
        + List Report
      </Menu.Item>
    </Menu>
  );

  const handleCreateClick = async (template) => {
    if (template.isUpcoming) {
      // console.log("clicked on gitlab");
      message.info('Coming Soon!');
      addActivityLog(
        props.workspace_id,
        `clicked on report ${template.name}`,
        'botui_cardskill_comingsoon',
        `clicked on report ${template.name}`
      );
      return;
    }

    try {
      const res = await checkConfigLimit(props.match.params.wId, 'config');
      if (!res.success) {
        message.error(res.message || 'Failed to check configuration limit.');
        return;
      }
    } catch (err) {
      console.error('handleCreateClick limit check error', err);
      message.error('Failed to check configuration limit. Please try again.');
      return;
    }

    let modal = await skillTokenValidation(template);
    if (modal === 'create_modal') {
      setShowCreationPage(true);
      setChartType(template.key == 'get_issues_by_jql' ? 'list' : 'chart');
      setSelectedTemplate(template);
      dispatch(handleTemplateFormat(template));
      dispatch(cardInfo(template.defaultValues));
    }
  };

  const handleShowCreationPage = (val) => {
    setShowCreationPage(val);
    if (val == false) {
      setSelectedCardSkill(null);
      setSelectedTemplate(null);
    }
  };

  const filteredSkills = newTemplateData.filter(
    (i) =>
      (i.key == 'jira_count_graph' ||
        i.key == 'jira_burn_down_chart' ||
        i.key == 'jira_velocity_chart' ||
        i.key == 'custom_report_2') &&
      !i.isHidden
  );
  // console.log(getReleventReports(cardSkillWithuser));

  const jiraSkill = props.skills.find((skill) => skill.key === 'jira');
  return (
    <Layout>
      {ShowCreationPage ? (
        <CreationPage
          setShowCreationPage={handleShowCreationPage}
          cardSkill={selectedCardSkill}
          template={selectedTemplate}
          setCurrent={(val) => setCurrentTab(val)}
          isEditMode={isEditMode}
          chartType={chartType}
          skill_type='app_home'
          setIsEditMode={(data) => setIsEditMode(data)}
        />
      ) : isReportLandingPage ? (
        <ReportLandingPage
          skillView={props.skillView}
          goToReports={goToReports}
          showConfigModal={showConfigModal}
          toggleSkill={toggleSkill}
          execRunNow={execRunNow}
          onReportDelete={onReportDelete}
          skill_type='app_home'
        />
      ) : (
        <>
          {!isReportLandingPage && (
            <PageHeader
              title='Personal reports'
              extra={
                isCreate
                  ? [
                    <Button
                      type='primary'
                      icon={isCreate && <CloseOutlined />}
                      onClick={() => {
                        return isCreate ? hideTemplates() : showTemplates();
                      }}
                    >
                      {isCreate ? 'Cancel' : 'Add Report'}
                    </Button>,
                    <Button
                      onClick={() => {
                        if (
                          !(
                            props.currentSkillUser &&
                            props.currentSkillUser.token_obj &&
                            props.currentSkillUser.token_obj.access_token
                          )
                        ) {
                          setWarning({
                            status: true,
                            skill: props.skill,
                            type: 'user_not_verified',
                          });
                        } else {
                          props.history.push(
                            `/${props.match.params.wId}/jiraConnectionSteps/${jiraSkill.skill_metadata._id}?domainName=${jiraSkill.skill_metadata.metadata.domain_url}&sub_skill=${props.match.params.sub_skill}&from=setup_demo_channel_button`
                          );
                        }
                      }}
                    >
                      Setup Demo Report
                    </Button>,
                  ]
                  : [
                    // <Button
                    //   onClick={() => {
                    //     if (
                    //       !(
                    //         props.currentSkillUser &&
                    //         props.currentSkillUser.token_obj &&
                    //         props.currentSkillUser.token_obj.access_token
                    //       )
                    //     ) {
                    //       setWarning({
                    //         status: true,
                    //         skill: props.skill,
                    //         type: 'user_not_verified',
                    //       });
                    //     } else {
                    //       props.history.push(
                    //         `/${props.match.params.wId}/jiraConnectionSteps/${jiraSkill.skill_metadata._id}?domainName=${jiraSkill.skill_metadata.metadata.domain_url}&sub_skill=${props.match.params.sub_skill}&from=setup_demo_channel_button`
                    //       );
                    //     }
                    //   }}>
                    //   Setup Demo Report
                    // </Button>,
                    // <Dropdown overlay={menu}>
                    // <Button
                    //   type='primary'
                    //   icon={<PlusOutlined />}
                    //   onClick={() => {
                    //     setShowChartReportPage(true);
                    //     setShowCreationPage(true);
                    //     setChartType('chart');
                    //     // if (!props.isEditMode) {
                    //     let res = newTemplateData.find(
                    //       (t) => t.key === 'custom_report_2'
                    //     );
                    //     dispatch(handleTemplateFormat(res));
                    //     setSelectedTemplate(res);
                    //     dispatch(cardInfo(res.defaultValues));

                    //     // }
                    //   }}
                    // >
                    //   {/* Add Report <DownOutlined /> */}
                    //   Personal Report
                    // </Button>,
                    // </Dropdown>
                    <Dropdown overlay={menu}>
                      <Button type='primary' icon={<PlusOutlined />}>
                        Add Report <DownOutlined />
                      </Button>
                    </Dropdown>,
                  ]
              }
              style={{ maxWidth: 1440, paddingBottom: 0 }}
            />
          )}
          <div style={{ margin: '0px 32px' }}>
            <Tabs
              onChange={(tab) => handleTabChange(tab)}
              activeKey={currentTab}
            >
              <TabPane tab='My Reports' key='my_reports' />
              {/* <TabPane tab='All Reports' key='all_reports' /> */}
              <TabPane tab='Report Templates' key='report_template' />
            </Tabs>
          </div>
          <Content
            style={{
              padding: !isReportLandingPage && '0px 32px 32px 32px',
              overflow: 'initial',
            }}
          >
            {(currentTab == 'my_reports' || currentTab == 'all_reports') && (
              <Table
                rowKey='_id'
                loading={loading || channelsLoading}
                columns={table_columns}
                dataSource={getReleventReports(cardSkillWithuser)}
                pagination={{ defaultPageSize: 20, showSizeChanger: true }}
              />
            )}

            {currentTab == 'report_template' && (
              <Card
                title='Choose a template below to get started'
                bodyStyle={
                  !props.skill
                    ? {
                      overflow: 'auto',
                      height: 'calc(100vh - 190px)',
                      justifyContent: 'flex-start',
                    }
                    : {}
                }
                // extra={<Button type="primary" icon={<CloseOutlined />} onClick={this.hideTemplates}>Cancel</Button>}
                loading={loading}
              >
                {/* <div style={{ marginBottom: '10px' }}>
                    {' '}
                    {props.showFilter &&
                      tagsFromServer.map((tag) => (
                        <CheckableTag
                          key={tag}
                          checked={selectedTags.indexOf(tag) > -1}
                          onChange={(checked) =>
                            this.handleCheckedtage(tag, checked)
                          }>
                          {tag}
                        </CheckableTag>
                      ))}
                  </div> */}

                <Row
                  gutter={[16, 16]}
                  justify='flex-start'
                // align='middle'
                // className='cardSkillDisplay'
                >
                  {filteredSkills.map((item) => (
                    <Col span={8} key={item._id}>
                      <div
                        onClick={() => {
                          handleCreateClick(item);
                        }}
                      >
                        {item.isUpcoming ? (
                          <Card
                            cover={
                              <div
                                style={{
                                  height: '200px',
                                  // 'url("https://app-stage.troopr.io/logo/test1.png")'
                                  backgroundImage: `url(${item.logo})`,
                                  backgroundPosition: 'center',
                                  backgroundSize: '220px',
                                  backgroundRepeat: 'no-repeat',
                                  backgroundColor: '#001529',
                                }}
                              />
                            }
                          >
                            <Meta
                              avatar={
                                item.app === 'Jira' ? (
                                  <Avatar
                                    src='https://app.troopr.io/logo/jira.png'
                                    shape='square'
                                  />
                                ) : (
                                  <Avatar
                                    icon={<GithubOutlined />}
                                    style={{ color: 'black' }}
                                  />
                                )
                              }
                              title={item.name}
                            />
                          </Card>
                        ) : (
                          <Card
                            hoverable
                            cover={
                              <div
                                style={{
                                  height: '200px',
                                  // 'url("https://app-stage.troopr.io/logo/test1.png")'
                                  backgroundImage: `url(${item.logo})`,
                                  backgroundPosition: 'center',
                                  backgroundSize: '220px',
                                  backgroundRepeat: 'no-repeat',
                                  backgroundColor: '#001529',
                                }}
                              />
                            }
                          >
                            <Meta
                              avatar={
                                item.app === 'Jira' ? (
                                  <Avatar
                                    src='https://app.troopr.io/logo/jira.png'
                                    shape='square'
                                  />
                                ) : (
                                  <Avatar
                                    icon={<GithubOutlined />}
                                    style={{ color: 'black' }}
                                  />
                                )
                              }
                              title={item.name}
                            />
                          </Card>
                        )}
                      </div>
                    </Col>
                  ))}
                </Row>
              </Card>
            )}

            {showEditModal && (
              <EditSkill
                skill_type='app_home'
                closeModal={() => setShowEditModal(false)}
                cardInfo={selectedCardSkill}
                visible={showEditModal}
              />
            )}
          </Content>
        </>
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  currentSkill: state.skills.currentSkill,
  currentSkillUser: state.skills.currentSkillUser,
  cardSkills: state.cards.cardSkills,
  cardTemplates: state.cards.templateCards,
  channels: state.skills.channels,
  allUsers: state.skills.members,
  user_now: state.common_reducer.user,
  isAdmin: state.common_reducer.isAdmin,
  skills: state.skills.skills,
});

export default withRouter(
  connect(mapStateToProps, {
    getCardSkills,
    excecuteCardSkill,
    updateCardSkills,
    getCardTemplates,
    getChannelList,
    getSkillUser,
    getCurrentSkill,
    deleteCardSkill,
    cardInfo,
  })(CardSkillList)
);
